import React, {forwardRef, HTMLAttributes} from 'react';
import cn from 'classnames';

export interface IconProps extends HTMLAttributes<HTMLElement> {
    /**
     * Name of the font icon
     */
    iconName: string;
    /**
     * Whether or not it's an icon from the UI font or not
     */
    isUiIcon?: boolean;
}

/**
 * Component, which uses the bosch icon font
 */
export const Icon = forwardRef<HTMLElement, IconProps>((props, ref) => {
    const {iconName, className, isUiIcon = false, ...rest} = props;
    const iconClass = cn('a-icon', {
        [className]: className,
        [`boschicon-bosch-ic-${iconName}`]: iconName && !isUiIcon,
        [`ui-ic-${iconName}`]: iconName && isUiIcon,
    });

    return <i ref={ref} className={iconClass} {...rest} />;
});

Icon.displayName = 'Icon';
